import React from 'react';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { openConfirmation } from 'helpers/Confirmation';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { bindLogger } from 'helpers/BindLogger';

import { testSiteRegistration } from 'actions/protocols/participation';

const styles = theme => ({
  textBox: {
    width: '100%'
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    marginLeft: 8,
    flex: 1,
    opacity: 1
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  }
});

const SiteRegistrationTestContainer = props => {
  const {
    classes, state, handleInputChange, onSiteRegistration
  } = props;

  return (
    <>
      <Typography data-id="siteRegTestEnterId" variant="body1" align="left" style={{ margin: '.5rem 0 .25rem' }}>
        Enter Site CTEP ID to see if they can participate
      </Typography>
      <ValidatorForm name="siteRegForm" onSubmit={onSiteRegistration}>
        <Paper className={`rounded ${classes.root}`} elevation={0} variant="outlined" style={{ padding: '.25rem', borderColor: '#D1E1E9' }}>
          <InputBase
            value={state || ''}
            className={classes.input}
            name="siteCtepId"
            placeholder="Enter Site CTEP ID"
            onChange={handleInputChange}
          />
          <Divider className={classes.divider} />
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            data-id="sitecodesubmit"
            name="sitecodesubmit"
            className="turquoise"
          >
  Test Site
          </Button>
        </Paper>
      </ValidatorForm>
    </>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocol: state.protocol,
    testSiteRegistration
  }),
  dispatch => bindActionCreators(
    {
      onTestSiteRegistration: testSiteRegistration
    },
    dispatch
  )
);

export function MsgSiteReg({ message, canParticipate }) {
  return `<div>
  <div class="row">
    <div class="col-5 mr-3 color-dark-blue align-right">Result</div>
    <div class="col-7"><span class="font-semibold">${canParticipate === true ? 'Yes' : 'No'}</span></div>
  </div>
  <div class="row mr-1">
    <div class="col-5 mr-3 color-dark-blue align-right">Message</div>
    <div class="col-7"><span class="font-semibold">${canParticipate === true ? 'Allowed to participate' : 'Not allowed to participate'}</span></div>
  </div>
 </div>`;
}

const SiteRegistrationTest = withStyles(styles)(
  compose(
    withState('state', 'setState', null),
    withConnectState,
    withAppContext,
    withHandlers({
      handleInputChange: props => event => {
        const { setState } = props;
        setState(event.target.value);
      },
      onSiteRegistration: props => event => {
        const {
          state,
          protocolNumber,
          context,
          onTestSiteRegistration
        } = props;
        bindLogger(onTestSiteRegistration, context)(
          protocolNumber,
          state
        ).subscribe(resp => {
          const close = () => {};
          openConfirmation({
            title: 'Site Participation Test Result',
            message: MsgSiteReg(resp.response),
            onAction: close,
            name: 'site_participation'
          });
        });
      }
    })
  )(SiteRegistrationTestContainer)
);

export { SiteRegistrationTest };
